module.exports = __webpack_public_path__ + "static/media/workPvcCoatings1.5283f66d.jpg";